<template>
    <div class="settingsform">
        <modal identifier="leaveeditquestion" ref="question" :question="question" :cancelText="cancelText" :confirmText="confirmText" :showTrigger="false" v-on:onConfirm="okClicked()" v-on:onCancel="cancelClicked()" confirmButtonClass="green" />
        <div class="row" v-if="role != 'ddd_customer'">
            <ul class="collapsible">
                <li>
                    <div class="collapsible-header">{{$t('settings.my_company')}}<i class="material-icons">expand_more</i></div>
                    <div class="collapsible-body nested-collapsible">
                        <ul class="collapsible">
                            <li>
                                <div class="collapsible-header">{{$t('settings.company_info')}} <i class="material-icons">expand_more</i></div>
                                <div class="collapsible-body formul">
                                    <div v-if="loaded">
                                        <div class="row">
                                            <div class="col l12 s12 labl">
                                                {{$t('settings.name')}} <div class="input-field inline"> <input type="text" v-model="settings.company.name" :disabled="!edit" />
                                                    <span class="helper-text" data-error="wrong" data-success="right" v-if="errors.name">{{errors.name.join(" ")}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col offset-l1 l1 right-align labl">
                                                {{$t('settings.nip')}} </div>
                                            <div class="col l2">
                                                <div class="input-field inline" style="width: 70%"><input type="text" v-model="settings.company.nip" :disabled="!edit" /></div>
                                            </div>
                                            <div class="col l1 right-align labl">
                                                {{$t('settings.krs')}} </div>
                                            <div class="col l2">
                                                <div class="input-field inline"><input type="text" v-model="settings.company.krs" :disabled="!edit" /></div>
                                            </div>
                                            <div class="col l2 right-align labl">
                                                {{$t('settings.regon')}} </div>
                                            <div class="col l2">
                                                <div class="input-field inline"><input type="text" v-model="settings.company.regon" :disabled="!edit" /></div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col offset-l1 l1 right-align labl">
                                                {{$t('settings.address')}} </div>
                                            <div class="col l3">
                                                <div class="input-field inline" style="width: 100%"><input type="text" v-model="settings.company.address_attributes.street" :disabled="!edit" />
                                                </div>
                                            </div>
                                            <div class="col l1 right-align labl">
                                                {{$t('settings.city')}} </div>
                                            <div class="col l2">
                                                <div class="input-field inline"><input type="text" v-model="settings.company.address_attributes.city" :disabled="!edit" />
                                                </div>
                                            </div>
                                            <div class="col l2 right-align labl">
                                                {{$t('settings.postal_code')}} </div>
                                            <div class="col l2">
                                                <div class="input-field inline"><input type="text" v-model="settings.company.address_attributes.postal_code" :disabled="!edit" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col l1 offset-l1 right-align labl">
                                                {{$t('settings.email')}} </div>
                                            <div class="col l3">
                                                <div class="input-field inline" style="width: 100%" v-bind:class="errors && errors.email ?  'errors' : ''"><input type="text" v-model="settings.company.email" :disabled="!edit" />
                                                    <span class="helper-text" data-error="wrong" data-success="right" v-if="errors.email">{{errors.email.join(" ")}}</span></div>
                                            </div>
                                            <div class="col l2 right-align labl">
                                                {{$t('settings.webpage')}} </div>
                                            <div class="col l3">
                                                <div class="input-field inline" style="width: 100%"><input type="text" v-model="settings.company.www" :disabled="!edit" /></div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col l1 offset-l1 right-align labl">
                                                {{$t('settings.phone_number')}} 1 </div>
                                            <div class="col l2">
                                                <div class="input-field inline"><input type="text" v-model="settings.company.phone" :disabled="!edit" /></div>
                                            </div>
                                            <div class="col l1 right-align labl"> {{$t('settings.phone_number')}} 2 </div>
                                            <div class="col l2">
                                                <div class="input-field inline"><input type="text" v-model="settings.company.cell_phone" :disabled="!edit" /></div>
                                            </div>
                                            <div class="col l5" v-if="settings.company.editable">
                                                <a v-on:click="edit = true" class="waves-effect waves-light btn-small right" v-if="edit == false">{{$t('menu.buttons.edit')}}</a>
                                            </div>
                                        </div> <br />
                                    </div>
                                    <div class="row" v-if="settings.company.editable">
                                        <div class="col s6 offset-l6 offset-xl6 right-align l3 xl3">
                                            <a v-on:click="cancelSettings()" class="waves-effect waves-light btn-small right-align cancelbutton" v-if="edit == true">{{$t('menu.buttons.cancel_changes')}}</a>
                                        </div>
                                        <div class="col s6 l3 xl3">
                                            <a v-on:click="save_settings()" class="waves-effect waves-light btn-small solidgreen" v-if="edit">
                                                <div v-if="saving" class="preloader-wrapper small active">
                                                    <div class="spinner-layer spinner-red-only">
                                                        <div class="circle-clipper left">
                                                            <div class="circle"></div>
                                                        </div>
                                                        <div class="gap-patch">
                                                            <div class="circle"></div>
                                                        </div>
                                                        <div class="circle-clipper right">
                                                            <div class="circle"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {{saving == false ? $t('menu.buttons.save_changes') : ""}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="collapsible-header">{{$t('settings.logotypes.title')}} <i class="material-icons">expand_more</i></div>
                                <div class="collapsible-body logoselector">
                                    <h6> {{$t('settings.logotypes.qr_codes')}} </h6>
                                    <div class="row">
                                        <div class="col s1" style="height: 175px; width: calc(100% / 12);">
                                            <img :src="settings.company.logo | tobase64" style="width: 100%; height: 100%;" />
                                        </div>
                                        <div class="col s3" style="height: 175px; align-items: end; font-size: 12px;">
                                            <div>
                                                {{$t('settings.logotypes.requirements')}}<br />
                                                {{$t('settings.logotypes.qr_codes_requirements')}}
                                            </div>
                                        </div>
                                        <div class="col s3" style="height: 175px; display: flex;">
                                            <button v-if="editlogo" class="waves-effect waves-light btn-small solidgreen" v-on:click="selectLogo()">{{$t('settings.logotypes.change')}}</button>
                                            <modal v-if="editlogo" :question="$t('settings.logotypes.remove_qrcode_question')" :confirmText="$t('menu.buttons.delete')" identifier="codeLogoRemoveQuestion" v-on:onConfirm="clearCodeLogo()" />
                                        </div>
                                    </div>
                                    <h6> {{$t('settings.logotypes.headers')}} </h6>
                                    <div class="row" style="padding: 25px;">
                                        <div class="col s8" style="height: 75px;">
                                            <img :src="settings.company.header_graphics | tobase64" style="width: 100%; height: 100%;" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div div class="col offset-s1 s3" style="font-size: 12px;">
                                            {{$t('settings.logotypes.requirements')}}: {{$t('settings.logotypes.headers_requirements')}}
                                        </div>
                                        <div class="col s3" style="height: 75px; display: flex; ">
                                            <button v-if="editlogo" class="waves-effect waves-light btn-small solidgreen" v-on:click="selectDocumentLogo()">
                                                {{$t('settings.logotypes.change')}}
                                            </button>
                                            <modal v-if="editlogo" :question="$t('settings.logotypes.remove_header_question')" :confirmText="$t('menu.buttons.delete')" identifier="headerLogoRemoveQuestion" v-on:onConfirm="clearHeaderLogo()" />
                                        </div>
                                    </div>
                                    <div class="row" style="margin-top: 25px;" v-if="settings.company.editable">
                                        <div class="col offset-l6 s3 l3">
                                            <a v-on:click="cancelEditLogos()" class="waves-effect waves-light btn-small cancelbutton" v-if="editlogo == true">{{$t('menu.buttons.cancel_changes')}}</a>
                                        </div>
                                        <div class="col s3 l3">
                                            <a v-on:click="editLogos()" class="waves-effect waves-light btn-small" v-if="editlogo == false">{{$t('menu.buttons.edit')}}</a>
                                            <a v-on:click="saveLogos()" class="waves-effect waves-light btn-small solidgreen" v-if="editlogo == true">
                                                <div v-if="savinglogos" class="preloader-wrapper small active">
                                                    <div class="spinner-layer spinner-red-only">
                                                        <div class="circle-clipper left">
                                                            <div class="circle"></div>
                                                        </div>
                                                        <div class="gap-patch">
                                                            <div class="circle"></div>
                                                        </div>
                                                        <div class="circle-clipper right">
                                                            <div class="circle"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {{savinglogos == false ? $t('menu.buttons.save_changes') : ""}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="collapsible-header">{{$t('settings.documents.title')}} <i class="material-icons">expand_more</i></div>
                                <div class="collapsible-body">
                                    <div class="row baseheader input-field" v-if="newDocument == null">
                                        <div class="col s2">
                                            <span v-on:click="setDocumentsOrder('created_at')">{{$t('settings.documents.date_added')}}</span>
                                            <i class="material-icons dp6" v-if="orderDocumentsBy == 'date' && orderdocuments == 'desc'">arrow_drop_down</i>
                                            <i class="material-icons dp6" v-if="orderDocumentsBy == 'date' && orderdocuments == 'asc'">arrow_drop_up</i>
                                        </div>
                                        <div class="col s3 input-field">
                                            <span v-on:click="setDocumentsOrder('name')">{{$t('settings.documents.name')}}</span>
                                            <i class="material-icons dp6" v-if="orderDocumentsBy == 'name' && orderdocuments == 'desc'">arrow_drop_down</i>
                                            <i class="material-icons dp6" v-if="orderDocumentsBy == 'name' && orderdocuments == 'asc'">arrow_drop_up</i>
                                            <input v-model="documentnamesearch" />
                                        </div>
                                        <div class="col s3 input-field">
                                            <span v-on:click="setDocumentsOrder('description')">{{$t('settings.documents.description')}}</span>
                                            <i class="material-icons dp6" v-if="orderDocumentsBy == 'description' && orderdocuments == 'desc'">arrow_drop_down</i>
                                            <i class="material-icons dp6" v-if="orderDocumentsBy == 'description' && orderdocuments == 'asc'">arrow_drop_up</i>
                                            <input v-model="documentdescriptionsearch" />
                                        </div>
                                        <div class="col s2">
                                            <span v-on:click="setDocumentsOrder('type')">{{$t('settings.documents.document_type')}}</span>
                                            <selector v-model="selecteddoctypes" :items="doctypes" identifier="doctypeselector"></selector>
                                            <i class="material-icons dp6" v-if="orderDocumentsBy == 'type' && orderdocuments == 'desc'">arrow_drop_down</i>
                                            <i class="material-icons dp6" v-if="orderDocumentsBy == 'type' && orderdocuments == 'asc'">arrow_drop_up</i>
                                        </div>
                                        <div class="col s2 input-field" style="text-align: end;" v-if="settings.company.editable">
                                            <a class="waves-effect waves-light btn solidgreen" v-on:click="addDocument()" style="margin-top: 20px;" v-if="newDocument == undefined">{{$t('settings.documents.add')}}</a>
                                        </div>
                                    </div>
                                    <template v-if="newDocument != null">
                                        <div class="row">
                                            <div class="col s2">
                                            </div>
                                            <div class="col s3 input-field">
                                                <input v-model="newDocument.name" :placeholder="$t('settings.documents.name_placeholder')" />
                                            </div>
                                            <div class="col s3  input-field">
                                                <input v-model="newDocument.description" :placeholder="$t('settings.documents.description_placeholder')" />
                                            </div>
                                            <div class="col s2 selectorignored">
                                                <select v-model="newDocument.type">
                                                    <option value="insurance">{{$t('settings.documents.types.insurance')}}</option>
                                                    <option value="certificate">{{$t('settings.documents.types.certificate')}}</option>
                                                    <option value="reference">{{$t('settings.documents.types.references')}}</option>
                                                    <option value="other_document">{{$t('settings.documents.types.other')}}</option>
                                                </select>
                                            </div>
                                            <div class="col s1" :class="{'docselector': (newDocument.file == undefined && newDocument.url == undefined)}" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                <label :for="'newdoc'" v-if="!newDocument.url">{{newDocument.file == undefined ? $t('settings.documents.selectfile') : newDocument.file.name}}</label>
                                                <input type="file" :id="'newdoc'" @change="setFile(newDocument, $event.target.name, $event.target.files)" v-if="!newDocument.url" hidden />
                                                <a :href="newDocument.url" v-if="newDocument.url">
                                                    <i class="material-icons">insert_drive_file</i>
                                                </a>
                                            </div>
                                            <div class="col s1">
                                                <modal :question="$t('settings.documents.remove_question')" :confirmText="$t('menu.buttons.delete')" identifier="customercontactremovequestion" v-on:onConfirm="removeDocument(newDocument)" v-if="editdocuments == true && (newDocument.url != undefined || newDocument.file != undefined)">
                                                    <p style="text-align: left;" v-html="$t('settings.documents.remove_question')"></p>
                                                </modal>
                                            </div>
                                        </div>
                                        <div class="row" style="margin-bottom: 16px !important;">
                                            <div class="col  offset-l8 s4 l2" style="text-align: right;">
                                                <button class="waves-effect waves-light btn-large cancelbutton" v-on:click="newDocument = null">{{$t('menu.buttons.cancel_changes')}}</button>
                                            </div>
                                            <div class="col l2 s4" style="text-align: right;">
                                                <a class="waves-effect waves-light btn-large emptygreen" v-on:click="saveDocument(newDocument)" style="width: 100%;">
                                                    {{$t('menu.buttons.save_changes')}}
                                                </a></div>
                                        </div>
                                    </template>
                                    <div class="row" v-for="(doc, index) in  listDocuments" v-show="!doc.destroy" :key="doc.id+':'+doc.type">
                                        <div class="col s2 input-field">
                                            <input type="date" class="datepicker" v-model="doc.created_at" :disabled="true">
                                        </div>
                                        <div class="col s3 input-field">
                                            <input v-model="doc.name" :disabled="editdocuments == false" :placeholder="$t('settings.documents.name_placeholder')" />
                                        </div>
                                        <div class="col s3  input-field">
                                            <input v-model="doc.description" :disabled="editdocuments == false" :placeholder="$t('settings.documents.description_placeholder')" />
                                        </div>
                                        <div class="col s2 selectorignored">
                                            <select v-model="doc.type" :disabled="editdocuments == false || doc.id">
                                                <option value="insurance">{{$t('settings.documents.types.insurance')}}</option>
                                                <option value="certificate">{{$t('settings.documents.types.certificate')}}</option>
                                                <option value="reference">{{$t('settings.documents.types.references')}}</option>
                                                <option value="other_document">{{$t('settings.documents.types.other')}}</option>
                                            </select>
                                        </div>
                                        <div class="col s1" :class="{'docselector': (doc.file == undefined && doc.url == undefined)}" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                            <label :for="'docs'+index" v-if="!doc.url">{{doc.file == undefined ? "Wybierz plik..." : doc.file.name}}</label>
                                            <input type="file" :id="'docs'+index" @change="setFile(doc, $event.target.name, $event.target.files)" v-if="!doc.url" hidden />
                                            <a :href="doc.url" v-if="doc.url">
                                                <i class="material-icons">insert_drive_file</i>
                                            </a>
                                        </div>
                                        <div class="col s1">
                                            <modal question="$t('settings.documents.remove_question')" :confirmText="$t('menu.buttons.delete')" identifier="customercontactremovequestion" v-on:onConfirm="removeDocument(doc)" v-if="editdocuments == true && (doc.id != undefined || doc.id != undefined)">
                                                <p style="text-align: left;" v-html="$t('settings.documents.remove_question_rich')"></p>
                                            </modal>
                                        </div>
                                    </div>
                                    <div class="row" v-if="settings.company.editable">
                                        <div class="col l3 xl3"></div>
                                        <div class="col l3 xl3"></div>
                                        <div class="col s6 right-align l3 xl3">
                                            <a v-on:click="cancelEditDocuments()" class="waves-effect waves-light btn-small cancelbutton" v-if="editdocuments == true">{{$t('menu.buttons.cancel_changes')}}</a>
                                        </div>
                                        <div class="col s6 l3 xl3">
                                            <a v-on:click="editdocuments = true" class="waves-effect waves-light btn-small" v-if="editdocuments == false">{{$t('menu.buttons.edit')}}</a>
                                            <a v-on:click="saveDocuments()" class="waves-effect waves-light btn-small  solidgreen" v-if="editdocuments">
                                                <div v-if="savingdocuments" class="preloader-wrapper small active">
                                                    <div class="spinner-layer spinner-red-only">
                                                        <div class="circle-clipper left">
                                                            <div class="circle"></div>
                                                        </div>
                                                        <div class="gap-patch">
                                                            <div class="circle"></div>
                                                        </div>
                                                        <div class="circle-clipper right">
                                                            <div class="circle"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {{savingdocuments == false ? $t('menu.buttons.save_changes') : ""}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
        <div class="row" v-if="role != 'ddd_customer'">
            <ul class="collapsible">
                <li>
                    <div class="collapsible-header">{{$t('settings.my_account')}} <i class="material-icons">expand_more</i></div>
                    <div class="collapsible-body">
                        <div class="row" v-if="loaded">
                            <div class="col s4">
                                <p style="font-size: 15px; text-align: left;">{{$t('settings.license.title')}}: {{settings.license.variant ? settings.license.variant : $t('settings.license.none')}}</p>
                                <p style="font-size: 15px; text-align: left;">{{$t('settings.license.subscription')}}: od {{settings.license.starts_at}} do {{settings.license.ends_at}}</p>
                                <p style="font-size: 15px; text-align: left;">{{$t('settings.license.left_codes')}}: {{settings.license.used}} z {{settings.license.limit || "∞"}}</p>
                                <div class="progress">
                                    <div class="determinate green" style="width: 70%;"></div>
                                </div>
                            </div>
                            <div class="col s12">
                                <autosizelabel :text="$t('settings.license.visit_store')" /> <a href="https://mobipest.eu/cennik/" class="waves-effect waves-light btn-small cancelbutton">{{$t('settings.license.go_shop')}}</a></div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="row">
            <collapsible :title="$t('settings.users_data')">
                <div>{{passwordchangeresult.notice}}</div>
                <div class="row">
                    <div class="col s1 labl">
                        {{$t('settings.user_account.login')}}
                    </div>
                    <div class="col s3 input-field"><input v-model="user_email" disabled /></div>
                </div>
                <div class="row">
                    <div class="col s2 labl" style="text-align: right;">
                        {{$t('settings.user_account.password')}}
                    </div>
                    <div class="col s3 input-field">
                        <input type="password" v-model="actual_password" autocomplete="new-password" />
                    </div>
                    <div class="col s3 labl" style="color: red;">
                        {{passworderrors.current_password}}
                    </div>
                </div>
                <div class="row">
                    <div class="col s2 labl" style="text-align: right;">
                        {{$t('settings.user_account.new_password')}}
                    </div>
                    <div class="col s3 input-field">
                        <input type="password" v-model="new_password" />
                    </div>
                    <div class="col s3 labl" style="color: red;">
                        <template v-if="passworderrors.password != undefined">
                            {{passworderrors.password[0]}}
                        </template>
                    </div>
                </div>
                <div class="row">
                    <div class="col s2 labl" style="text-align: right;">
                         {{$t('settings.user_account.new_password_confirm')}}
                    </div>
                    <div class="col s3 input-field">
                        <input type="password" v-model="new_password_confirm" />
                    </div>
                    <div class="col s3 labl" style="color: red;">
                        <template v-if="passworderrors.password_confirmation != undefined">
                            {{passworderrors.password_confirmation[0]}}
                        </template>
                    </div>
                </div>
                <div class="row">
                    <div class="col offset-s5 s2" style="text-align: right;">
                        <button class="btn btn-small green" v-on:click="changePassword()">{{$t('settings.user_account.change_button')}}</button>
                    </div>
                </div>
            </collapsible>
        </div>
        <div class="row" v-if="role != 'ddd_customer'">
            <ul class="collapsible">
                <li>
                    <div class="collapsible-header">{{$t('settings.mobipest_notifications')}} <i class="material-icons">expand_more</i></div>
                    <div class="collapsible-body">
                        <div class="row" v-for="subscription in settings.subscriptions" v-if="!subscription._destroy">
                            <div class="col s5 l5" v-bind:class="subscription.errors && subscription.errors.email ?  'errors' : ''">
                                <autosizelabel :text="$t('settings.notifications.notify')" />
                                <div class="input-field inline" style="display: flex; max-height: 60px;">
                                    <input v-model="subscription.email" :disabled="editsubscriptions == false" />
                                    <span class="helper-text" data-error="wrong" data-success="right" v-if="subscription.errors && subscription.errors.email">{{subscription.errors.email.join(" ")}}</span>
                                </div>
                            </div>
                            <div class="col s5 selectorignored">
                                <autosizelabel text="O:" />
                                <div class="input-field" style="display: flex; max-height: 60px;">
                                    <select v-model="subscription.kind" :disabled="editsubscriptions == false">
                                        <option value="codes">{{$t('settings.notifications.codes')}}</option>
                                        <option value="inspection">{{$t('settings.notifications.inspection')}}</option>
                                        <option value="installation">{{$t('settings.notifications.installation')}}</option>
                                        <option value="intervention">{{$t('settings.notifications.intervention')}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col s1">
                                <a v-on:click="removeSubscription(subscription)" class="waves-effect waves-light btn-small red" v-if="editsubscriptions == true">{{$t('menu.buttons.delete')}}</a>
                            </div>
                        </div>
                        <div class="row" v-if="settings.company.editable">
                            <div class="col s4" style="margin-top: 5px;">
                                <a v-on:click="addSubscription()" class="waves-effect waves-light btn-small solidgreen">{{$t('settings.notifications.add_notification')}}</a>
                            </div>
                            <div class="col s right-align" style="margin-top: 5px;">
                                <a v-on:click="cancelSettingsSubscriptions()" class="waves-effect waves-light btn-small cancelbutton" v-if="editsubscriptions == true">{{$t('menu.buttons.cancel_changes')}}</a>
                            </div>
                            <div class="col  s6" style="margin-top: 5px;">
                                <a v-on:click="editsubscriptions = true" class="waves-effect waves-light btn-small" v-if="editsubscriptions == false && subscriptions.length > 0">{{$t('menu.buttons.edit')}}</a>
                                <a v-on:click="save_settings_subscriptions()" class="waves-effect waves-light btn-small solidgreen" v-if="editsubscriptions">
                                    <div v-if="saving_subscriptions" class="preloader-wrapper small active">
                                        <div class="spinner-layer spinner-red-only">
                                            <div class="circle-clipper left">
                                                <div class="circle"></div>
                                            </div>
                                            <div class="gap-patch">
                                                <div class="circle"></div>
                                            </div>
                                            <div class="circle-clipper right">
                                                <div class="circle"></div>
                                            </div>
                                        </div>
                                    </div>
                                    {{saving_subscriptions == false ? $t('menu.buttons.save_changes') : ""}}
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="row" v-if="role != 'ddd_customer'">
            <ul class="collapsible">
                <li>
                    <div class="collapsible-header">{{$t('settings.surveys')}} <i class="material-icons">expand_more</i></div>
                    <div class="collapsible-body nested-collapsible">
                        <ul class="collapsible">
                            <li>
                                <div class="collapsible-header">{{$t('settings.sanitary_conditions.title')}} <i class="material-icons">expand_more</i></div>
                                <div class="collapsible-body">
                                    <div v-for="question in settings.questions" class="selectorignored">
                                        <div class="row" v-if="!question._destroy">
                                            <div class="col s1">
                                                {{$t('settings.sanitary_conditions.question')}}
                                            </div>
                                            <div class="col s6">
                                                <div class="input-field">
                                                    <input v-model="question.text" :disabled="editquestions == false" />
                                                </div>
                                            </div>
                                            <div class="col s2">
                                                <input type="checkbox" v-model="question.yes_generate_recommendation" :disabled="editquestions == false" />
                                                <label>
                                                    <input type="checkbox" v-model="question.yes_generate_recommendation" :disabled="editquestions == false" />
                                                    <span>{{$t('settings.sanitary_conditions.generate_recommendation')}}</span>
                                                </label>
                                            </div>
                                            <div class="col s1">
                                                <modal :question="$t('settings.sanitary_conditions.remove_question')" :confirmText="$t('menu.buttons.delete')" identifier="removeQuestionDialog" v-on:onConfirm="removeQuestion(question)" v-if="editquestions == true">
                                                    <p style="text-align: left;" v-html="$t('settings.documents.remove_question_rich')"></p>
                                                </modal>
                                            </div>
                                        </div>
                                        <div class="row" v-if="question.yes_generate_recommendation && !question._destroy">
                                            <div class="col offset-s1 s8" style="border: 1px solid; padding-top: 15px; padding-left: 15px; padding-bottom: 5px;">
                                                <div class="row">
                                                    <div class="col s1">{{$t('settings.sanitary_conditions.description')}}</div>
                                                    <div class="col s11">
                                                        <div class="input-field"><input v-model="question.yes_recommendation_problem" :placeholder="$t('settings.sanitary_conditions.description_placeholder')" v-if="question.yes_generate_recommendation" :disabled="editquestions == false" /></div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col s2">{{$t('settings.sanitary_conditions.cause')}}</div>
                                                    <div class="col s10">
                                                        <div class="input-field"><input v-model="question.yes_recommendation_cause" :placeholder="$t('settings.sanitary_conditions.cause_placeholder')" v-if="question.yes_generate_recommendation" :disabled="editquestions == false" /></div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col s2">{{$t('settings.sanitary_conditions.kind')}}</div>
                                                    <div class="col s4">
                                                        <select v-model="question.yes_recommendation_kind" :disabled="editquestions == false">
                                                            <option value="correction">{{$t('recommendations.correction')}}</option>
                                                            <option value="fixing">{{$t('recommendations.repairs')}}</option>
                                                            <option value="prevention">{{$t('recommendations.prevention')}}</option>
                                                            <option selected="selected" value="emergency">{{$t('recommendations.emergency')}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col s2">{{$t('settings.sanitary_conditions.solution')}}</div>
                                                    <div class="col s10">
                                                        <div class="input-field"><input v-model="question.yes_recommendation_solution" :placeholder="$t('settings.sanitary_conditions.solution_placeholder')" v-if="question.yes_generate_recommendation" :disabled="editquestions == false" /></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-top: 25px;" v-if="settings.company.editable">
                                        <div class="col offset-s1 s2">
                                            <a v-on:click="addQuestion()" class="waves-effect waves-light btn-small green">{{$t('settings.sanitary_conditions.add')}}</a>
                                        </div>
                                        <div class="col s6 offset-l1 l3 right-align">
                                            <a v-on:click="cancelSettingsQuestions()" class="waves-effect waves-light btn-small cancelbutton" v-if="editquestions == true">{{$t('menu.buttons.cancel_changes')}}</a>
                                        </div>
                                        <div class="col s6 l2 right-align">
                                            <a v-on:click="editquestions = true" class="waves-effect waves-light btn-small" v-if="editquestions == false && settings.questions.length > 0">{{$t('menu.buttons.edit')}}</a>
                                            <a v-on:click="save_settings_questions()" class="waves-effect waves-light btn-small emptygreen" v-if="editquestions == true">
                                                <div v-if="saving_questions" class="preloader-wrapper small active">
                                                    <div class="spinner-layer spinner-red-only">
                                                        <div class="circle-clipper left">
                                                            <div class="circle"></div>
                                                        </div>
                                                        <div class="gap-patch">
                                                            <div class="circle"></div>
                                                        </div>
                                                        <div class="circle-clipper right">
                                                            <div class="circle"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {{saving_questions == false ? $t('menu.buttons.save_changes') : ""}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
        <div class="row" v-if="role != 'ddd_customer'">
            <ul class="collapsible">
                <li>
                    <div class="collapsible-header">{{$t('settings.customer_accounts.title')}}<i class="material-icons">expand_more</i></div>
                    <div class="collapsible-body nested-collapsible ikks">
                        <table>
                            <thead>
                                <tr>
                                    <th v-on:click="kset_order('number')" style="width: 7%; vertical-align: baseline;">
                                        <span>{{$t('settings.customer_accounts.number')}}</span>
                                        <i class="material-icons dp6" v-if="usersorderby == 'number' && korder == 'desc'">arrow_drop_down</i>
                                        <i class="material-icons dp6" v-if="usersorderby == 'number' && korder == 'asc'">arrow_drop_up</i>
                                        <div class="input-field col s6">
                                            <input id="number" type="text" class="validate" v-model="knumbersearch">
                                        </div>
                                    </th>
                                    <th v-on:click="kset_order('name')" style="width: 25%; vertical-align: baseline;">
                                        <span>{{$t('settings.customer_accounts.name')}}</span>
                                        <i class="material-icons dp6" v-if="usersorderby == 'name' && korder == 'desc'">arrow_drop_down</i>
                                        <i class="material-icons dp6" v-if="usersorderby == 'name' && korder == 'asc'">arrow_drop_up</i>
                                        <div class="input-field col s6">
                                            <input id="name" type="text" class="validate" v-model="knamesearch">
                                        </div>
                                    </th>
                                    <th v-on:click="kset_order('email')" style="width: 25%; vertical-align: baseline;">
                                        <span>{{$t('customer.email')}}</span>
                                        <i class="material-icons dp6" v-if="usersorderby == 'email' && korder == 'desc'">arrow_drop_down</i>
                                        <i class="material-icons dp6" v-if="usersorderby == 'email' && korder == 'asc'">arrow_drop_up</i>
                                        <div class="input-field col s6">
                                            <input id="address" type="text" class="validate" v-model="kemailsearch">
                                        </div>
                                    </th>
                                    <th v-on:click="kset_order('last_login')" style="width: 25%; vertical-align: baseline;">
                                        <span>{{$t('customer.last_loggedin')}}</span>
                                        <i class="material-icons dp6" v-if="usersorderby == 'last_login' && korder == 'desc'">arrow_drop_down</i>
                                        <i class="material-icons dp6" v-if="usersorderby == 'last_login' && korder == 'asc'">arrow_drop_up</i>
                                    </th>
                                    <th v-on:click="kset_order('status')" style="width: 18%; vertical-align: baseline;">
                                        <span>{{$t('customer.status')}}</span>
                                        <i class="material-icons dp6" v-if="usersorderby == 'status' && korder == 'asc'">arrow_drop_down</i>
                                        <i class="material-icons dp6" v-if="usersorderby == 'status' && korder == 'desc'">arrow_drop_up</i>
                                        <div class="input-field col s12 statuses">
                                            <selector v-model="kstatus" :items="statuses" identifier="statuses"></selector>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user in listUserAccounts">
                                    <td>{{user.number}}</td>
                                    <td>{{user.name}}</td>
                                    <td>{{user.email}}</td>
                                    <td>
                                        <template v-if="user.id != undefined && user.not_accepted_invitation == false">
                                            <template v-if="user.last_login != null">
                                                {{user.last_login | formatDate}}
                                            </template>
                                            <template v-else>{{user.updated_at | formatDate}}</template>
                                        </template>
                                        <template v-else>----</template>
                                    </td>
                                    <td>
                                        <template v-if="user.id != undefined && user.not_accepted_invitation">
                                            {{$t('customer.not_activated')}}
                                        </template>
                                        <template v-if="user.id != undefined && user.not_accepted_invitation == false">
                                            {{$t('customer.activated')}}
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </li>
            </ul>
            <ul class="collapsible">
                <li>
                    <div class="collapsible-header">{{$t('settings.interventions')}}<i class="material-icons">expand_more</i></div>
                    <div class="collapsible-body nested-collapsible">
                        <ul class="collapsible">
                            <li>
                                <div class="collapsible-header">{{$t('settings.protocol_sentences.title')}} <i class="material-icons">expand_more</i></div>
                                <div class="collapsible-body">
                                    <div class="row" style="margin-top: 25px;" v-if="settings.intervention_methods.length > 0">
                                        <div class="col s4 l4">{{$t('settings.protocol_sentences.method')}}</div>
                                        <div class="col s6 l6">{{$t('settings.protocol_sentences.text')}}</div>
                                    </div>
                                    <div class="row" v-for="intervention_method in settings.intervention_methods" v-show="!intervention_method._destroy">
                                        <div class="col s4 input-field"><input v-model="intervention_method.name" :disabled="editinterventions == false" /></div>
                                        <div class="col s6 input-field"><input v-model="intervention_method.description" :disabled="editinterventions == false" /></div>
                                        <div class="col s1">
                                            <a v-on:click="removeInterventionMethod(intervention_method)" class="waves-effect waves-light btn-small red" v-if="editinterventions == true">{{$t('menu.buttons.delete')}}</a>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-top: 25px;" v-if="settings.company.editable">
                                        <div class="col s6 l3">
                                            <a v-on:click="addInterventionMethod()" class="waves-effect waves-light btn-small green">Dodaj metodę</a>
                                        </div>
                                        <div class="col s6 offset-l3 l3 right-align ">
                                            <a v-on:click="cancelEditInterventions()" class="waves-effect waves-light btn-small cancelbutton" v-if="editinterventions == true">{{$t('menu.buttons.cancel_changes')}}</a>
                                        </div>
                                        <div class="col s6 l3">
                                            <a v-on:click="editInterventionMethods()" class="waves-effect waves-light btn-small" v-if="editinterventions == false && settings.intervention_methods.length > 0">{{$t('menu.buttons.edit')}}</a>
                                            <a v-on:click="save_settings_interventions()" class="waves-effect waves-light btn-small emptygreen" v-if="editinterventions == true">
                                                <div v-if="saving_interventions" class="preloader-wrapper small active">
                                                    <div class="spinner-layer spinner-red-only">
                                                        <div class="circle-clipper left">
                                                            <div class="circle"></div>
                                                        </div>
                                                        <div class="gap-patch">
                                                            <div class="circle"></div>
                                                        </div>
                                                        <div class="circle-clipper right">
                                                            <div class="circle"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {{saving_interventions == false ? $t('menu.buttons.save_changes') : ""}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="collapsible-header">{{$t('settings.announcement.title')}} <i class="material-icons">expand_more</i></div>
                                <div class="collapsible-body">
                                    <div class="row" v-for="announcement in settings.announcements" v-if="!announcement._destroy">
                                        <div class="col s11">
                                            <editable :placeholder="announcement.default" v-model="announcement.text" :disabled="editannouncements == false"></editable>
                                        </div>
                                        <div class="col s1">
                                            <modal :question="$t('settings.announcement.question')" :confirmText="$t('menu.buttons.delete')" identifier="customercontactremovequestion" v-on:onConfirm="removeAnnouncement(announcement)" v-if="editannouncements">
                                                <p style="text-align: left;">
                                                    <p style="text-align: left;" v-html="$t('settings.announcement.question_rich')"></p> 
                                                </p>
                                            </modal>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-top: 25px;" v-if="settings.company.editable">
                                        <div class="col s2">
                                            <a v-on:click="addAnnouncement()" class="waves-effect waves-light btn-small green">{{$t('settings.announcement.add')}}</a>
                                        </div>
                                        <div class="col offset-s4 s3 offset-l5 l3 right-align">
                                            <a v-on:click="cancelSettingsAnnouncement()" class="waves-effect waves-light btn-small cancelbutton" v-if="editannouncements == true">{{$t('menu.buttons.cancel_changes')}}</a>
                                        </div>
                                        <div class="col s3 l2 right-align">
                                            <a v-on:click="editAnnouncements()" class="waves-effect waves-light btn-small" v-if="editannouncements == false && settings.questions.length > 0">{{$t('menu.buttons.edit')}}</a>
                                            <a v-on:click="save_settings_announcements()" class="waves-effect waves-light btn-small emptygreen" v-if="editannouncements == true">
                                                <div v-if="savingannouncements" class="preloader-wrapper small active">
                                                    <div class="spinner-layer spinner-red-only">
                                                        <div class="circle-clipper left">
                                                            <div class="circle"></div>
                                                        </div>
                                                        <div class="gap-patch">
                                                            <div class="circle"></div>
                                                        </div>
                                                        <div class="circle-clipper right">
                                                            <div class="circle"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {{savingannouncements == false ? $t('menu.buttons.save_changes') : ""}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
import * as DOMPurify from 'dompurify';
export default {
    props: { role: String, email: String, user_email: String },
    data: function() {
        return {
            order: 1,
            korder: 'asc',
            orderby: 'number',
            usersorderby: 'number',
            passworderrors: {},
            passwordchangeresult: {},
            edit: false,
            editsubscriptions: false,
            editlogo: false,
            savinglogos: false,
            editquestions: false,
            saving_subscriptions: false,
            editinterventions: false,
            saving_questions: false,
            saving_interventions: false,
            savingannouncements: false,
            editdocuments: false,
            savingdocuments: false,
            editannouncements: false,
            settings: {
                company: {},
                questions: [],
                intervention_methods: [],
                subscriptions: []
            },
            statuses: [
                { name: this.$t('customer.not_activated'), value: true },
                { name: this.$t('customer.activated'), value: false }
            ],
            kstatus: [false],
            knumbersearch: '',
            knamesearch: '',
            kemailsearch: '',
            emailsearch: '',
            customersearch: '',
            old_settings: {},
            subscriptions: [],
            users: [],
            documents: [],
            errors: {},
            newDocument: null,
            saving: false,
            loaded: false,
            doctypes: [
                { "value": "insurance", "name": this.$t('settings.documents.types.insurance') },
                { "value": "certificate", "name":this.$t('settings.documents.types.certificate') },
                { "value": "reference", "name": this.$t('settings.documents.types.references') },
                { "value": "other_document", "name": this.$t('settings.documents.types.other') }
            ],
            orderDocumentsBy: "date",
            orderdocuments: "asc",
            documentnamesearch: "",
            documentdescriptionsearch: "",
            documenttypesselect: [],
            selecteddoctypes: [],
            actual_password: "",
            new_password: "",
            new_password_confirm: "",
            question: "",
            cancelText: "",
            confirmText: ""
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.edit || this.editsubscriptions || this.editlogo || this.editquestions || this.editdocuments || this.editannouncements || this.editinterventions) {
            this.question = this.$t('menu.save_question');
            this.cancelText = this.$t('menu.buttons.save_cancel')
            this.confirmText = this.$t('menu.buttons.save_changes')
            this.$refs.question.open();
            this.callback = next;
        } else {
            next()
        }
    },
    created() {
        var that = this;
        if (this.role != 'ddd_customer') {
            axios.get('/customers/users.json').then(response => {
                this.users = _.flatten(_.map(response.data, function(customer) {
                    return customer.users;
                }));
            })
            axios.get('/settings.json').then(response => {
                that.settings = response.data
                that.subscriptions = that.settings.subscriptions
                that.old_settings = _.cloneDeep(response.data)
                that.loaded = true;
                that.documents = that.deserializeDocuments(this.old_settings);
                that.init_collapsibles();
            })
        } else {
            this.loaded = true;
            this.init_collapsibles();
        }
    },
    methods: {
        saveDocument: async function(newDocument){
            // this.documents.push(newDocument)
            var docs = this.serializeDocuments([newDocument]);
            var resp = await axios.put('/settings/update.json', docs)
            this.old_settings = _.cloneDeep(resp.data)
            this.documents = this.deserializeDocuments(this.old_settings);
            this.newDocument = null;
        },
        save_settings: function() {
            this.saving = true;
            axios.put('/settings/update.json', this.settings).then(response => {
                this.saving = false;
                this.edit = false;
                this.errors = {};
                this.old_settings = _.cloneDeep(response.data)
            }).catch(e => {
                if (e.response.status == 422) {
                    this.saving = false;
                    this.errors = e.response.data.company.errors
                }
            })
        },
        cancelSettings: function() {
            this.settings = _.cloneDeep(this.old_settings);
            this.edit = false;
        },
        setDocumentsOrder: function(order) {
            if (this.orderDocumentsBy == order) {
                if (this.orderdocuments == 'desc') {
                    this.orderdocuments = 'asc'
                } else if (this.orderdocuments == 'asc') {
                    this.orderdocuments = 'desc'
                }
            } else {
                this.orderDocumentsBy = order;
            }
        },
        setFile: function(doc, name, file) {
            doc.file = file[0];
        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
        kset_order: function(order) {
            if (this.usersorderby == order) {
                if (this.korder == 'desc') {
                    this.korder = 'asc'
                } else if (this.korder == 'asc') {
                    this.korder = 'desc'
                }

            } else {
                this.usersorderby = order;
            }
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 1) {
                    this.order = 0
                } else if (this.order == 0) {
                    this.order = 1
                }

            } else {
                this.orderby = order;
            }
        },
        init_collapsibles: function() {
            var elems = document.querySelectorAll('.collapsible');
            var instances = M.Collapsible.init(elems, { accordion: false });
            var elems = document.querySelectorAll('.datepicker');
            var instances = M.Datepicker.init(elems, { format: "yyyy-mm-dd" });
            // M.AutoInit();

        },

        mounted() {
            // M.AutoInit();

        },
        save_settings_subscriptions: async function() {
            try {
                this.saving_subscriptions = true;
                var response = await axios.put('/settings/update.json', { company: { subscriptions_attributes: this.settings.subscriptions } }
                )
                this.settings.subscriptions = _.cloneDeep(response.data.subscriptions)
            } catch (err) {
                if( err.response ){
                    this.settings.subscriptions = _.cloneDeep(err.response.data.subscriptions)
                }
            }
            this.saving_subscriptions = false;
        },
        save_settings_interventions() {
            this.saving_interventions = true
            axios.put('/settings/update.json', { company: { intervention_methods_attributes: this.settings.intervention_methods } }).then(response => {
                this.saving_interventions = false;
                this.editinterventions = false;
                this.errors = {};
                this.old_settings = _.cloneDeep(response.data)
            })
        },
        selectLogo() {
            var input = document.createElement('input');
            input.type = 'file';
            var that = this;
            input.onchange = e => {
                var file = e.target.files[0];
                if (file.type == "image/svg+xml") {
                    var reader = new FileReader();
                    reader.onload = function(evt) {
                        that.settings.company.logo = evt.target.result;
                    };
                    reader.readAsText(file, "UTF-8");
                } else {
                    alert(this.$t('settings.logotypes.invalid_svg'));
                }
            }

            input.click();
        },
        async changePassword() {
            this.passworderrors = {};
            const formData = new FormData();
            formData.append("settings[current_password]", this.actual_password);
            formData.append("settings[new_password]", this.new_password);
            formData.append("settings[new_password_confirmation]", this.new_password_confirm);
            try {
                var resp = await axios.patch('/settings/update_password.json', formData);
                this.passwordchangeresult = resp.data;
                this.actual_password = "";
                this.new_password = "";
                this.new_password_confirm = "";
            } catch (error) {
                if (error.response && error.response.status == 422) {
                    this.passworderrors = error.response.data;

                }
            }

        },
        editLogos() {
            this.editlogo = true;
            this.oldLogo = this.settings.company.logo;
            this.oldHeader = this.settings.company.header_graphics;
        },
        clearCodeLogo() {
            axios.put('/settings/update.json', { company: { logo: '<svg xmlns="http://www.w3.org/2000/svg"><text x="0" y="15">' + this.settings.company.name + '</text></svg>' } }).then(
                response => {
                    this.savinglogos = false;
                    this.settings.company.logo = response.data.company.logo;
                    this.oldLogo = this.settings.company.logo;
                    this.editlogo = false;
                });
        },
        clearHeaderLogo() {
            axios.put('/settings/update.json', { company: { header_graphics: '<svg xmlns="http://www.w3.org/2000/svg"><text x="0" y="15">' + this.settings.company.name + '</text></svg>' } }).then(
                response => {
                    this.savinglogos = false;
                    this.settings.company.header_graphics = response.data.company.header_graphics;
                    this.oldHeader = this.settings.company.header_graphics;
                    this.editlogo = false;
                });
        },
        cancelEditLogos() {
            this.editlogo = false;
            this.settings.company.logo = this.oldLogo;
            this.settings.company.header_graphics = this.oldHeader;
        },
        saveLogos() {
            this.savinglogos = true;
            axios.put('/settings/update.json', { company: { logo: this.settings.company.logo, header_graphics: this.settings.company.header_graphics } }).then(
                response => {
                    this.savinglogos = false;
                    this.editlogo = false;
                });
        },
        selectDocumentLogo() {
            var input = document.createElement('input');
            input.type = 'file';
            var that = this;
            input.onchange = e => {
                var file = e.target.files[0];
                if (file.type == "image/svg+xml") {
                    var reader = new FileReader();
                    reader.onload = function(evt) {
                        that.settings.company.header_graphics = evt.target.result;
                    };
                    reader.readAsText(file, "UTF-8");
                } else {
                    alert(this.$t('settings.logotypes.invalid_svg'));
                }
            }

            input.click();
        },
        cancelSettingsSubscriptions() {
            this.settings.subscriptions = _.cloneDeep(this.old_settings.subscriptions);
            this.editsubscriptions = false;
        },
        removeSubscription(subscription) {
            if (_.isUndefined(subscription.id)) {
                this.settings.subscriptions.splice(this.settings.subscriptions.indexOf(subscription), 1)
            } else {
                subscription._destroy = true
            }
            this.$forceUpdate();
        },
        removeQuestion(question) {
            if (_.isUndefined(question.id)) {
                this.settings.questions.splice(this.settings.questions.indexOf(question), 1)
            } else {
                question._destroy = true
            }
            this.$forceUpdate();
        },
        removeDocument(doc) {
            if (_.isUndefined(doc.id)) {
                this.documents.splice(this.documents.indexOf(doc), 1)
            } else {
                doc.destroy = true
            }
            this.$forceUpdate();
        },
        removeInterventionMethod(interventionmethod) {
            if (_.isUndefined(interventionmethod.id)) {
                this.settings.intervention_methods.splice(this.settings.intervention_methods.indexOf(interventionmethod), 1)
            } else {
                interventionmethod._destroy = true
            }
            this.$forceUpdate();
        },
        addSubscription() {
            this.editsubscriptions = true;
            this.settings.subscriptions.push({ email: "", kind: "inspection" })
        },
        addDocument() {
            this.newDocument = { date: moment().format("YYYY-MM-DD"), name: "", description: "", file: undefined }
            this.$forceUpdate()
        },
        addQuestion() {
            this.editquestions = true;
            this.settings.questions.push({})
            this.$forceUpdate()
        },
        editInterventionMethods() {
            this.editinterventions = true;
            this.old_settings.intervention_methods = _.cloneDeep(this.settings.intervention_methods)
        },
        addInterventionMethod() {
            if (!this.editinterventions) this.editInterventionMethods()
            this.settings.intervention_methods.push({})
            this.$forceUpdate()
        },
        save_settings_questions() {
            this.saving_questions = true;
            axios.put('/settings/update.json', { company: { helping_questions_attributes: this.settings.questions } }).then(response => {
                this.saving_questions = false;
                this.editquestions = false;
                this.errors = {};
                this.old_settings = _.cloneDeep(response.data)
            })
        },
        cancelSettingsQuestions() {
            this.editquestions = false;
            this.settings.questions = _.cloneDeep(this.old_settings.questions)
        },
        cancelEditDocuments() {
            this.editdocuments = false;
            this.documents = this.deserializeDocuments(this.old_settings)
            this.savingdocuments = false;
        },
        cancelEditInterventions() {
            this.editinterventions = false;
            this.saving_interventions = false;
            this.settings.intervention_methods = _.cloneDeep(this.old_settings.intervention_methods);
        },
        serializeDocuments(documents){
            var insurances = 0;
            var certificates = 0;
            var references = 0;
            var other_documents = 0;
            const formData = new FormData();
            for (var doc of documents) {
                if (doc.type == "insurance") {
                    if (doc.id) formData.append('company[insurances_attributes][' + insurances + '][id]', doc.id);
                    formData.append('company[insurances_attributes][' + insurances + '][policy_no]', doc.name);
                    formData.append('company[insurances_attributes][' + insurances + '][description]', doc.description);
                    formData.append('company[insurances_attributes][' + insurances + '][valid_until]', doc.date);
                    if (doc.destroy) formData.append('company[insurances_attributes][' + insurances + '][_destroy]', true);
                    if (doc.file) formData.append('company[insurances_attributes][' + insurances + '][document_asset_attributes][attachment]', doc.file);
                    insurances += 1;
                } else if (doc.type == "reference") {
                    if (doc.id) formData.append('company[references_attributes][' + references + '][id]', doc.id);
                    formData.append('company[references_attributes][' + references + '][name]', doc.name);
                    formData.append('company[references_attributes][' + references + '][description]', doc.description);
                    formData.append('company[references_attributes][' + references + '][date]', doc.date);
                    if (doc.destroy) formData.append('company[references_attributes][' + references + '][_destroy]', true);
                    if (doc.file) formData.append('company[references_attributes][' + references + '][document_asset_attributes][attachment]', doc.file);
                    references += 1;
                } else if (doc.type == "certificate") {
                    if (doc.id) formData.append('company[certificates_attributes][' + certificates + '][id]', doc.id);
                    formData.append('company[certificates_attributes][' + certificates + '][name]', doc.name);
                    formData.append('company[certificates_attributes][' + certificates + '][description]', doc.description);
                    formData.append('company[certificates_attributes][' + certificates + '][date]', doc.date);
                    if (doc.destroy) formData.append('company[certificates_attributes][' + certificates + '][_destroy]', true);
                    if (doc.file) formData.append('company[certificates_attributes][' + certificates + '][document_asset_attributes][attachment]', doc.file);
                    certificates += 1;
                } else if (doc.type == "other_document") {
                    if (doc.id) formData.append('company[other_documents_attributes][' + other_documents + '][id]', doc.id);
                    formData.append('company[other_documents_attributes][' + other_documents + '][name]', doc.name);
                    formData.append('company[other_documents_attributes][' + other_documents + '][description]', doc.description);
                    formData.append('company[other_documents_attributes][' + other_documents + '][date]', doc.date);
                    if (doc.destroy) formData.append('company[other_documents_attributes][' + other_documents + '][_destroy]', true);
                    if (doc.file) formData.append('company[other_documents_attributes][' + other_documents + '][document_asset_attributes][attachment]', doc.file);
                    other_documents += 1;
                }

            }
            return formData;
        },
        deserializeDocuments(settings){
            var docs = []
            for (var insurance of settings.insurances) {
                docs.push({
                    id: insurance.id,
                    type: "insurance",
                    created_at: moment(insurance.created_at).format(moment.HTML5_FMT.DATE),
                    name: insurance.policy_no,
                    url: insurance.url,
                    description: (_.isNil(insurance.description) && moment(insurance.date).isValid() ? moment(insurance.date).format("DD.MM.YYYY") : insurance.description),
                    date: insurance.valid_until
                })
            }
            for (var reference of settings.references) {
                docs.push({
                    id: reference.id,
                    created_at: moment(reference.created_at).format(moment.HTML5_FMT.DATE),
                    type: "reference",
                    url: reference.url,
                    date: reference.date,
                    description: reference.description,
                    name: reference.name
                })
            }
            for (var certificate of settings.certificates) {
                docs.push({
                    id: certificate.id,
                    type: "certificate",
                    created_at: moment(certificate.created_at).format(moment.HTML5_FMT.DATE),
                    url: certificate.url,
                    date: certificate.date,
                    description: (_.isNil(certificate.description) && moment(certificate.date).isValid() ? moment(certificate.date).format("DD.MM.YYYY") : certificate.description),
                    name: certificate.name
                })
            }
            for (var other_document of settings.other_documents) {
                docs.push({
                    id: other_document.id,
                    type: "other_document",
                    url: other_document.url,
                    created_at: moment(other_document.created_at).format(moment.HTML5_FMT.DATE),
                    date: other_document.date,
                    description: (_.isNil(other_document.description) && moment(other_document.date).isValid() ? moment(other_document.date).format("DD.MM.YYYY") : other_document.description),
                    name: other_document.name
                })
            }
            return docs;
        },
        saveDocuments() {
            this.savingdocuments = true
            var formData = this.serializeDocuments(this.documents)
            axios.put('/settings/update.json', formData).then(response => {
                this.savingdocuments = false;
                this.editdocuments = false;
                this.errors = {};
                this.old_settings = _.cloneDeep(response.data)
                this.documents = [];
                this.newDocument = null;
                this.documents = this.deserializeDocuments(this.old_settings)
            })
        },
        editAnnouncements() {
            this.editannouncements = true;
            this.old_settings.announcements = _.cloneDeep(this.settings.announcements)
        },
        addAnnouncement() {
            this.editAnnouncements();
            this.settings.announcements.push({});
        },
        cancelSettingsAnnouncement() {
            this.editannouncements = false;
            this.settings.announcements = _.cloneDeep(this.old_settings.announcements)
        },
        save_settings_announcements() {
            this.editannouncements = true;
            this.savingannouncements = true;
            var c = 0;
            const formData = new FormData();
            for (var doc of this.settings.announcements) {
                if (doc.id) formData.append('company[announcements_attributes][' + c + '][id]', doc.id);
                formData.append('company[announcements_attributes][' + c + '][text]', this.convertToPlain(doc.text));
                if (doc._destroy) formData.append('company[announcements_attributes][' + c + '][_destroy]', true);
                c += 1;
            }
            axios.put('/settings/update.json', formData).then(response => {
                this.savingannouncements = false;
                this.editannouncements = false;
            })
        },
        removeAnnouncement(announcement) {
            if (_.isUndefined(announcement.id)) {
                this.settings.announcements.splice(this.settings.announcements.indexOf(announcement), 1)
            } else {
                announcement._destroy = true
            }
            this.$forceUpdate();
        },
        cancelClicked() {
            this.callback();
        },
        okClicked() {

        },
        convertToPlain: function(html){
            return _.trim(DOMPurify.sanitize(html, {ALLOWED_TAGS: ['%text', 'div']}).replaceAll('<div>','\n').replaceAll('</div>','').replaceAll('&nbsp;', " "));
        }
    },
    computed: {
        listDocuments() {
            var that = this;
            return _.filter(
                _.orderBy(this.documents, this.orderDocumentsBy, this.orderdocuments),
                function(item) {
                    return (
                        (that.selecteddoctypes.indexOf(item.type) > -1 || that.selecteddoctypes.length == 0) &&
                        (("" + item.name).toUpperCase().indexOf(that.documentnamesearch.toUpperCase()) >= 0) &&
                        (("" + item.description).toUpperCase().indexOf(that.documentdescriptionsearch.toUpperCase()) >= 0)
                    )
                }
            );
        },
        listUserAccounts() {
            var that = this;
            return _.filter(
                _.orderBy(this.users, this.usersorderby, this.korder),
                function(item) {
                    return (
                        (("" + item.number).toUpperCase().indexOf(that.knumbersearch.toUpperCase()) >= 0) &&
                        (("" + item.name).toUpperCase().indexOf(that.knamesearch.toUpperCase()) >= 0) &&
                        (("" + item.email).toUpperCase().indexOf(that.kemailsearch.toUpperCase()) >= 0) &&
                        (that.kstatus.length == 0 || that.kstatus.indexOf(item.not_accepted_invitation) > -1)
                    )
                }
            );
        }
    },

}
</script>
<style scoped>
.settingsform >>> .btn-small {
    margin: 0px !important;
}
.login_button {
    color: red;
}

p {
    font-size: 2em;
    text-align: center;
}

nav {
    background-color: #626262;
    height: 100px;
}

nav a {
    margin: 15px;
}

.settingsform {
    padding-top: 15px;
}

.settingsform .input-field {
    margin-top: 0rem;
    margin-bottom: 0rem;
}

.settingsform input {
    margin-bottom: 0rem;
}

.selectorignored select {
    display: block;
}

thead {
    background-color: #DADADA;
    font-size: 20px;
}

thead th {
    font-weight: 300;
}

thead .input-field {
    margin-top: unset;
    margin-bottom: unset;
}

/deep/ .collapsible-header, .collapsible-header:focus{
    background-color: #bebbbb !important;
    text-transform: uppercase;
}

/deep/ .active>.collapsible-header {
    background-color: #C22026 !important;
}

.collapsible {

    margin-left: 15px;
    margin-right: 15px;
    box-shadow: 0 0px 0px;
    border: 0px;
}

/deep/ .collapsible li {
    padding-bottom: 15px;
}

.nested-collapsible {
    padding-right: 0px;
    padding-bottom: 0px;
    border-bottom-width: 0px;
}

.nested-collapsible .collapsible {
    margin-right: 0px;
}

.formul .row .col {
    padding-bottom: 15px;
}

.formul .s12 .input-field {
    width: 90%
}

.formul .s4 .input-field {
    width: 60%
}

.formul .s6 .input-field {
    width: 60%
}

.settingsform>.row {
    margin-bottom: 0px;
}

.settingsform>.row>.collapsible {
    margin-bottom: 0px;
}

.settingsform .btn-small {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.solidgreen {
    background-color: #00CC66 !important;
}

select {
    display: block;
}

/deep/ .collapsible li .collapsible-header>i {
    position: absolute;
    right: 15px;
}

li.active>.collapsible-header>i {
    -ms-transform: rotate(180deg);
    /* IE 9 */
    -webkit-transform: rotate(180deg);
    /* Chrome, Safari, Opera */
}

select {
    border-radius: 5px;
    border-color: rgba(0, 0, 0, 0.42);
    height: 36px;
}

.labl {
    padding-top: 8px;
}

/deep/ .collapsible-body {
    display: none;
    border-bottom: 0px solid #ddd;
    padding: 15px;
}

.progress {
    height: 25px;
    background-color: white;
    border: 1px solid #bbb;
}

.green {
    background-color: #00CC66 !important;
}

.btn-small {
    color: black;
    border-radius: 8px;
}

.red {
    background-color: #C22026 !important;
}

.baseheader {
    background-color: #DADADA;
    padding-bottom: 15px;
    margin-bottom: 10px;
}

.row {
    margin-top: 5px;
}

.ikks .input-field {
    width: 100%;
    padding-left: 5px;
    padding-right: 5px;
}

.ikks span {
    padding-left: 5px;
    font-size: 15px;
}

.ikks th {
    padding: 2px;
}

/deep/ .statuses input {
    font-size: 10px !important;
}

.docselector {
    border: 1px solid #eee;
    padding-top: 5px;
    padding-bottom: 5px;
    border-radius: 5px;
    border-color: rgba(0, 0, 0, .42);
}

select:disabled {
    color: rgba(0, 0, 0, 1.0) !important;
    border-color: rgb(140, 140, 140) !important;
    opacity: 1.0 !important;
    margin-bottom: 0px !important;
}

.solidgreen {
    background-color: #00CC66 !important;
    color: black;
}

.cancelbutton {
    background-color: #FFF !important;
    border-color: #9e9e9e !important;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.errors input{
    border-color: #C22026 !important;
    margin-bottom: 0px !important;
}
.errors span{
    color: #C22026;
}
</style>
